var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { class: _vm.containerClass, on: { scroll: _vm.onScroll } },
    [
      _vm.hasTitleSlot
        ? _c(
            "div",
            { staticClass: "flex-level jc-space mb-3" },
            [
              _c(
                "h2",
                { staticClass: "m-0 typographies-heading-h2" },
                [
                  _vm._t("title"),
                  _vm._v(" "),
                  _c(
                    "span",
                    { staticClass: "grey ml-2" },
                    [_vm._t("subtitle")],
                    2
                  )
                ],
                2
              ),
              _vm._v(" "),
              _vm._t("buttons", [
                _vm.buttons && _vm.buttons.length > 0
                  ? _c(
                      "ul",
                      { staticClass: "list-inline" },
                      _vm._l(_vm.buttons, function(button, index) {
                        return _c(
                          "li",
                          { key: index },
                          [
                            _c(
                              "el-tooltip",
                              {
                                attrs: {
                                  content: _vm.$t.__(
                                    "common.labels.no_necessary_rights"
                                  ),
                                  placement: "top",
                                  disabled: _vm.hasAccess(
                                    button.permission,
                                    _vm.permissions
                                  )
                                }
                              },
                              [
                                button.type === "vuejs"
                                  ? _c(
                                      "a",
                                      {
                                        staticClass: "btn-compass-ish",
                                        class: !_vm.hasAccess(
                                          button.permission,
                                          _vm.permissions
                                        )
                                          ? "btn-compass-ish--disabled"
                                          : button.primary
                                          ? "btn-compass-ish--primary"
                                          : "btn-compass-ish--secondary",
                                        attrs: {
                                          "data-upsell": button.dataUpsell
                                        },
                                        on: {
                                          click: function($event) {
                                            return _vm.callBus(button, {
                                              linkedid: button.linkedid,
                                              linkedtype: button.linkedtype
                                            })
                                          }
                                        }
                                      },
                                      [
                                        _vm._v(
                                          "\n                            " +
                                            _vm._s(button.label) +
                                            "\n                        "
                                        )
                                      ]
                                    )
                                  : button.type === "function"
                                  ? _c(
                                      "a",
                                      {
                                        staticClass: "btn-compass-ish",
                                        class: !_vm.hasAccess(
                                          button.permission,
                                          _vm.permissions
                                        )
                                          ? "btn-compass-ish--disabled"
                                          : button.primary
                                          ? "btn-compass-ish--primary"
                                          : "btn-compass-ish--secondary",
                                        attrs: {
                                          "data-upsell": button.dataUpsell
                                        },
                                        on: {
                                          click: function($event) {
                                            _vm.$emit(button.event, {
                                              params: {
                                                linkedid: button.linkedid,
                                                linkedtype: button.linkedtype
                                              },
                                              disabled: !_vm.hasAccess(
                                                button.permission,
                                                _vm.permissions
                                              )
                                            })
                                          }
                                        }
                                      },
                                      [
                                        _vm._v(
                                          "\n                            " +
                                            _vm._s(button.label) +
                                            "\n                        "
                                        )
                                      ]
                                    )
                                  : _c(
                                      "a",
                                      {
                                        staticClass: "btn-compass-ish",
                                        class: !_vm.hasAccess(
                                          button.permission,
                                          _vm.permissions
                                        )
                                          ? "btn-compass-ish--disabled"
                                          : button.primary
                                          ? "btn-compass-ish--primary"
                                          : "btn-compass-ish--secondary",
                                        attrs: {
                                          href: "javascript:;",
                                          "data-upsell": button.dataUpsell,
                                          onclick: !_vm.hasAccess(
                                            button.permission,
                                            _vm.permissions
                                          )
                                            ? null
                                            : _vm.buildUrl(
                                                button.callback,
                                                _vm.parameters
                                              )
                                        }
                                      },
                                      [
                                        _vm._v(
                                          "\n                            " +
                                            _vm._s(button.label) +
                                            "\n                        "
                                        )
                                      ]
                                    )
                              ]
                            )
                          ],
                          1
                        )
                      }),
                      0
                    )
                  : _vm._e()
              ])
            ],
            2
          )
        : _vm._e(),
      _vm._v(" "),
      _vm._t("content", [_vm._t("placeholder")])
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }